<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-2">
        <v-card elevation="0" height="92vh" class="main-dashboard-115-card body-card">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12">
                    <span class="title-dashboards">داشبورد وضعیت اپراتور 115</span>
                  </v-col>

                  <agent-status-grid :agents="fakeAgents" />


                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '../../components/AlertComponent.vue';

import Shared from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import Dashboard115Helper from '@/Helpers/115/Dashboard115Helper.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import AgentStatusGrid from '@/views/Dashboards/AgentStatusGrid.vue';
import fakeAgents from './fakeAgents.js';
export default {
  name: 'Dashboards_115_TimeStatus',
  title: 'داشبورد وضعیت اپراتور 115',
  components: { AlertComponent, AgentStatusGrid },
  mixins: [Shared, DashboardMixin, Dashboard115Helper, snackBar, ShearedMixin],
  created() {
    this.$root.$refs.Dashboards115TimeStatus = this;
  },
  mounted() {
    this.mounteLoding();
  },
  beforeDestroy() {
    clearInterval(this.dashboard115TimeInterval);
    this.dashboard115TimeInterval = null;
    delete this.$root.$refs.Dashboards115TimeStatus;
  },
  data() {
    return {
      newCall: false,
      fakeAgents
    };
  },
  methods: {
    mounte: function () {
      this.get115DashboardFunction();
    },
  },
};
</script>

<style lang="scss">
.bgCardAb_115 {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
}

.bgCardLineAb_115 {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0.2;
}


.cardTopStyle_115 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
  height: 100%;
  padding: 16px 24px;

  .iconStyle {
    background: white;
    padding: 10px !important;
    border-radius: 50% !important;
    box-shadow: 0px 5px 15px -5px var(--v-secondary-base)
  }

  .txt_title {
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }

  .txt_count {
    color: var(--v-darkColor-base);
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 1.3px;
    margin-right: auto;
  }
}

.styleCard_second_115 {
  height: 100%;

  .boxMain {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    height: 100%;


    .boxTxtIcon {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 20px;
      flex: 1;
      z-index: 3;

      .iconStyle {
        background: white;
        padding: 10px !important;
        border-radius: 50% !important;
        box-shadow: 0px 5px 15px -5px var(--v-darkColor-lighten2)
      }

      .item {
        display: flex;
        // flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 20px;

        .txt_count {
          color: #2d3748;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          letter-spacing: 1.3px;
        }

        .txt_title {
          color: #132440;
          font-size: 16px;
          font-style: normal;
          font-weight: normal;
        }

      }
    }
  }
}
</style>

<style scoped>
>>>.v-sheet.v-card {
  box-shadow: 2px 2px 10px -4px var(--v-darkColor-lighten1) !important;
}

.title-dashboards {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  font-weight: 500;
  color: var(--dark-color);
}

.main-dashboard-115-card {
  border-radius: 10px !important;
  border: 1px solid var(--dark-color) !important;
}

.body-card {
  overflow: hidden;
}

.body-card:hover {
  overflow-y: auto;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
  overflow: hidden;
}

.data-card1 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-darken4) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-darken2) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-lighten1) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card4 {
  height: 100%;
  background: linear-gradient(250deg, var(--v-primary-lighten2) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

>>>.second-row-img {
  position: absolute;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}
</style>
